<template>
	<div class="main">
		<EnterPhoneNumber v-if="currentStep === PHONE_NUMBER_VERIFICATION_STEPS.ENTER_PHONE_NUMBER"
			@close="closePhoneNumberEnterDialog" @phoneNumberEntered="onPhoneNumberEntered($event)" :phoneNumberInput="pNumber">
		</EnterPhoneNumber>

		<EnterOTP v-else-if="currentStep === PHONE_NUMBER_VERIFICATION_STEPS.ENTER_OTP" @otpEntered="onOTPEntered"
			@close="closeEnterOTPDialog" @back="backFromEnterOTPDialog" :phoneNumberInput="pNumber">
		</EnterOTP>

		<VerificationComplete v-else-if="currentStep === PHONE_NUMBER_VERIFICATION_STEPS.VERIFICATION_COMPLETE"
			@close="closeClicked"></VerificationComplete>
	</div>
</template>

<script setup lang="ts">
import { ref, inject, provide } from 'vue';
import type { VerifyPhoneNumberInput } from '@/interfaces/InHouseTasks/VerifyPhoneNumberInput';
import { PHONE_NUMBER_VERIFICATION_STEPS } from '@/constants/PhoneNumberVerificationSteps';

import EnterOTP from '@/components/PhoneVerification/Enter-OTP.vue'
import EnterPhoneNumber from '@/components/PhoneVerification/Enter-Phone-Number.vue'
import VerificationComplete from '@/components/PhoneVerification/Verification-Complete.vue'

const props = withDefaults(defineProps<{
	phoneNumberInput?: VerifyPhoneNumberInput
	phoneNumberVerificationStep?: PHONE_NUMBER_VERIFICATION_STEPS
}>(), {
	phoneNumberInput: () => ({
		phone_number: '',
		phone_country_code: '',
			phone_iso_code: ''
	}),
	phoneNumberVerificationStep: PHONE_NUMBER_VERIFICATION_STEPS.ENTER_PHONE_NUMBER
});

const emit = defineEmits<{
	(e: 'close'): void
}>();

const pNumber = ref<VerifyPhoneNumberInput>(props.phoneNumberInput);
const currentStep = ref<PHONE_NUMBER_VERIFICATION_STEPS>(props.phoneNumberVerificationStep);

const openDialog = inject<{ value: boolean }>('inHouseTaskOpenDialog') ?? inject<{ value: boolean }>('openForOTPResend');
provide('openDialog', openDialog);

const onPhoneNumberEntered = (phoneNumberInput: VerifyPhoneNumberInput) => {
	pNumber.value = phoneNumberInput;
	currentStep.value = PHONE_NUMBER_VERIFICATION_STEPS.ENTER_OTP;
};

const closePhoneNumberEnterDialog = () => {
	currentStep.value = PHONE_NUMBER_VERIFICATION_STEPS.ENTER_PHONE_NUMBER;
	if (openDialog) openDialog.value = false;
	emit("close");
};

const closeEnterOTPDialog = () => {
	currentStep.value = PHONE_NUMBER_VERIFICATION_STEPS.ENTER_PHONE_NUMBER;
};

const onOTPEntered = () => {
	currentStep.value = PHONE_NUMBER_VERIFICATION_STEPS.VERIFICATION_COMPLETE;
};

const backFromEnterOTPDialog = () => {
	currentStep.value = PHONE_NUMBER_VERIFICATION_STEPS.ENTER_PHONE_NUMBER;
};

const closeClicked = () => {
	emit("close");
};
</script>